var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"header"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/logoAEL70.png")}})])])}]

export { render, staticRenderFns }